import { INPUT_WIDTHS, LABEL_WIDTHS } from '../../constants/inlineLayout';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useRelatedConditionsHeading } from '../../hooks/useRelatedConditionsHeading';
import ConditionBox from '../common/ConditionBox';
import EditorFilterGroupHeadCondition from './EditorFilterGroupHeadCondition';
import EditorIncludeObjectsWithNoAssociatedObjectsInput from './EditorIncludeObjectsWithNoAssociatedObjectsInput';
import EditorUnifiedEventRefinements from './EditorUnifiedEventRefinements';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterGroupHeadConditionResponsive = ({
  conditionPath,
  logicGroup
}) => {
  const {
    width
  } = useElementSize();
  const {
    filterFamilyHeading,
    selectInput,
    showUnifiedEventRefinements
  } = useRelatedConditionsHeading(conditionPath, logicGroup);
  const {
    onConditionDelete
  } = useEditorActions();
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorFilterGroupHeadCondition, {
      conditionPath: conditionPath,
      logicGroup: logicGroup
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      isFilterBranch: true,
      onConditionDelete: () => onConditionDelete(conditionPath),
      children: [/*#__PURE__*/_jsx(UITruncateString, {
        maxWidth: LABEL_WIDTHS[width.size],
        children: filterFamilyHeading
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: `${INPUT_WIDTHS[width.size]}px`
        },
        children: selectInput
      })]
    }), /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoAssociatedObjectsInput, {
      conditionPath: conditionPath,
      logicGroup: logicGroup
    }), showUnifiedEventRefinements && /*#__PURE__*/_jsx(EditorUnifiedEventRefinements, {
      conditionPath: conditionPath,
      logicGroup: logicGroup
    })]
  });
};
export default EditorFilterGroupHeadConditionResponsive;